import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex } from 'ui/acro'
import { ChevronRightIcon } from 'components_v2/Icons'
import { AltHeaderText, HeaderCTAText } from '../../styles'

const AltSectionHeader = ({ headerText, linkId, linkHref, cta }) => {
  return (
    <Flex
      px={['16px', '16px', '16px', '0px']}
      mb={['16px', '16px', '16px', '24px']}
      mt={['16px', '16px', '16px', '0px']}
      justifyContent='space-between'
      alignItems='center'
    >
      <AltHeaderText as='div'>{headerText}</AltHeaderText>
      <HeaderCTAText id={linkId} as='a' className='unstyled' href={linkHref}>
        <span>{cta}</span>
        {cta && (
          <Box display={['none', null, null, 'inline-block']} paddingLeft='7px'>
            {' '}
            <ChevronRightIcon color='black' />
          </Box>
        )}
      </HeaderCTAText>
    </Flex>
  )
}

AltSectionHeader.propTypes = {
  headerText: PropTypes.string.isRequired,
  linkId: PropTypes.string,
  linkHref: PropTypes.string,
  cta: PropTypes.string
}

export default AltSectionHeader
